<template>
  <div v-show="shownVideoPoster" class="wt-infobar-toolbar">
    <!-- <div class="-divider" /> -->
    <wt-video-poster-toggle ref="videoPosterToggle" :asset="workModel" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import WtVideoPosterToggle from 'AssetEditor/functionality/Poster/wtVideoPosterToggle.vue';

export default Vue.extend({
  components: {
    WtVideoPosterToggle,
  },

  data() {
    return {
      shownVideoPoster: false,
    };
  },

  computed: {
    ...mapGetters('assetEditor', ['workModel']),
  },
  mounted() {
    this.shownVideoPoster = this.$refs.videoPosterToggle.isRelevant;
  },

  methods: {},
});
</script>

<style lang="scss" scoped>
.wt-infobar-toolbar {
  display: flex;
  align-items: center;
}

.-divider {
  display: inline;
  width: 0;
  height: 17px;
  border-right: 1px solid $color-black-l;
  margin: 0 15px;

  &:first-child,
  &:last-child {
    display: none;
  }
}

.-set-as-thumbnail {
  > span {
    margin-right: 5px;
  }
  font-size: 14px;
  display: inline-flex;
  justify-content: space-between;
}
</style>
